import './FrontB.sass';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';

import { useArticles } from '../api';
import Meta from '../components/Meta';

const FrontB = (props) => {
	const { routeData } = props;
	const { articles, breadcrumbs } = useArticles(routeData.guid, routeData.route, 10, 1, '');

	return (
		<div className='FrontB'>
			<Meta data={articles[0]} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='content' dangerouslySetInnerHTML={{ __html: articles[0]?.contents }}></div>
			</div>
		</div>
	);
};

export default FrontB;
